// A note in the security log that something sensitive was exported or downloaded (System & backup → Security log).
// Never throws: the export itself matters more than the note.
import { API } from './api.js';
export const audit = (kind, detail) => { try { API.call('audit.note', { kind, detail }).catch(() => {}); } catch (_) {} };
